export interface CallSpeechMetricsModel {
    clientSentimentEnd: string | null;
}
